import { render, staticRenderFns } from "./ScanDialog.vue?vue&type=template&id=47672f36&scoped=true&"
import script from "./ScanDialog.vue?vue&type=script&lang=js&"
export * from "./ScanDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47672f36",
  null
  
)

export default component.exports